import React from "react";

const Input = ({
  id,
  type,
  value,
  onChange,
  className,
  placeholder,
  disabled,
  accept,
}) => {
  return (
    <>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        className={className}
        placeholder={placeholder}
        disabled={disabled}
        accept={accept}
      />
    </>
  );
};

export default Input;
